module.exports = __webpack_public_path__ + "static/img/sg.b7c7bc4d.svg";